// Copyright (c) 2017 Deere & Company

import './product-details.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Accordions from '../state/accordions';
import ActionsPopover from '../../../shared/components/actions-popover';
import AmountOfUseHistoryPanel from './amount-of-use-history-panel/';
import BaseMachinePanel from './base-machine-panel';
import Claim from '@deere/cps-it.warranty-model-factory/lib/claim';
import ClaimHistoryPanel from './claim-history-panel';
import ComponentsPanel from './components-panel';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerPanel from '../../../shared/components/customer-panel/customer-panel';
import ExternalNotes from '@deere/cps-it.warranty-model-factory/lib/external-notes';
import ExternalNotesPanel from './external-notes-panel';
import {FormattedMessage} from 'react-intl';
import Implements from '@deere/cps-it.warranty-model-factory/lib/implements';
import IncentivePrograms from '@deere/cps-it.warranty-model-factory/lib/incentive-programs';
import IncentiveProgramsPanel from './incentive-programs-panel';
import InternalNotesPanel from './internal-notes-panel';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import MaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/maintenance-plan';
import MaintenancePlanPanel from './maintenance-plan-panel';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import Modal from '../../shared/state/modal';
import Option from '@deere/cps-it.warranty-model-factory/lib/option';
import OptionCodesPanel from './option-codes-panel';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import PipHistoryPanel from './pip-history-panel';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductComponent from '@deere/cps-it.warranty-model-factory/lib/component';
import ProductInfoPanel from '../../shared/components/product-info-panel/product-info-panel';
import PurchaseInfoPanel from './purchase-info-panel';
import RegistrationHistory from '@deere/cps-it.warranty-model-factory/lib/registration-history';
import RegistrationHistoryPanel from './registration-history-panel';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import WarrantyCoverage from './warranty-coverage-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getCustomerPanelActions} from '../../../shared/services/customer-panel-actions';
import {getProductActions} from '../../shared/services/product-actions';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';

const showDisabledClass = status =>
    ['EOOS', 'SCRP', 'VOID'].some(item => status === item);

function handleStatusChangeModalVisibility(value) {

    this.actions.updateProductDetailsStatusChangeModal('isVisible', value);

}

function handleAmountOfUseModalClose() {

    this.actions.updateAmountOfUseModalVisibility(false);

}

function handleAmountOfUseModalOpen() {

    this.actions.updateAmountOfUseModalVisibility(true);

}

function handleEditAmountOfUseModalClose() {

    this.actions.updateEditAmountOfUseModalVisibility(false);
    this.actions.resetAddAmountPerUnitMeasurements();

}

function handleEditAmountOfUseModalOpen() {

    this.actions.updateEditAmountOfUseModalVisibility(true);

}

function handleUpdateStatus() {

    this.actions.updateProductDetailsStatusChangeModal('isVisible', false);
    this.actions.goToStatusChangeRequestView(this.product.pin);

}

function handleCloseCreateClaimModal() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleClick(key, pin) {

    this.actions.onCreateClaim(key, pin);

}

function onAccordionToggle(name, isExpanded) {

    this.actions.toggleAccordion(name, isExpanded);

}

function onAccordionButtonClick(isExpanded) {

    this.actions.toggleAccordions(isExpanded);

}

function linkToMaintenancePlanPanel() {

    this.actions.toggleAccordion('maintenancePlanIsExpanded', true);

    const element = document.getElementsByClassName('maintenance-plan-accordion')[0];

    element.scrollIntoView();

}

function handleComponentDelete(id) {

    const component = this.components.find(c => c.id === id);

    this.actions.deleteProductComponent(this.product.pin, id, component);

}

function handlePartNumberBlur(partNumber) {

    this.actions.readPartDetails(partNumber);

}

function handleInputChange(property, value) {

    this.actions.updateComponentToAdd(property, value);

}

function handleCreateComponent() {

    this.actions.createComponent(this.product.pin, this.componentToAdd);

}

function handleOptionDelete(id) {

    this.actions.deleteProductOption(this.product.pin, id);

}

function handleCreateOption() {

    this.actions.createOption(this.product.pin, this.optionToAdd);

}

function handleOptionInputChange(property, value) {

    this.actions.updateOptionToAdd(property, value);

}

function handlePurchaseOrderChange(value) {

    this.actions.updatePurchaseOrder(value);

}

function handleComponentsChange(value) {

    this.actions.updateComponents(value);

}

function handleBaseMachineImplements() {

    this.actions.updateBaseMachineImplements(this.baseMachineComponents, this.routeParams.pin);

}

function handleCancelImplements() {

    this.actions.updateImplements(this.routeParams.pin);

}

class ProductDetails extends Component {

    componentWillMount() {

        this.props.actions.updateProductDetails(this.props.routeParams.pin);
        this.props.actions.readComponentCodes();

    }

    componentWillReceiveProps(newProps) {

        if (newProps.routeParams.pin !== this.props.routeParams.pin) {

            this.props.actions.resetProductDetails();
            this.props.actions.resetCkcCustomerFailure();
            this.props.actions.updateProductDetails(newProps.routeParams.pin);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetCkcCustomerFailure();
        this.props.actions.resetProductDetails();
        this.props.actions.resetLatestPerUnitMeasurements();
        this.props.actions.updateAmountOfUseModalVisibility(false);

    }

    render() {

        const actionList = getProductActions(this.context, this.props.product, this.props.actions.updateCreateClaimModalVisibility, this.props.isSapUp);
        const customerPanelActionList = getCustomerPanelActions(this.context, this.props.customer, this.props.actions.customerPanelRegistration);
        const hasComponentValue = this.props.baseMachineComponents.components && this.props.baseMachineComponents.components.every(component => component.isEditable === false);
        const isSubmitDisabled = this.props.baseMachinePurchaseOrder !== '' && hasComponentValue;

        return (
            <div className='product-details'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <header>
                    <h2 className='product-pin'>{this.props.product.pin}</h2>
                    <section className='button-group'>
                        {actionList.length > 0 &&
                            <ActionsPopover options={actionList}/>
                        }
                        {hasAccess(this.context.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(this.context.user.privacy, 'registrationNotAllowed') &&
                            <a
                                className='primary-action'
                                href={`#/products/register-product?pin=${this.props.product.pin}`}
                            >
                                <FormattedMessage id='REGISTER_PRODUCT'/>
                            </a>
                        }
                    </section>
                </header>
                <main>
                    <ProductInfoPanel
                        actions={this.props.actions}
                        amountOfUseHistory={this.props.amountOfUseHistory}
                        changeModalVisibility={this.props::handleStatusChangeModalVisibility}
                        isAmountOfUseModalOpen={this.props.isAmountOfUseModalOpen}
                        isSapUp={this.props.isSapUp}
                        isUpdateAmountOfUseModalOpen={this.props.isAmountOfUseEditModalOpen}
                        measurementReadings={this.props.measurementReadings}
                        onAmountOfUseModalClose={this.props::handleAmountOfUseModalClose}
                        onAmountOfUseModalOpen={this.props::handleAmountOfUseModalOpen}
                        onUpdateAmountOfUseModalClose={this.props::handleEditAmountOfUseModalClose}
                        onUpdateAmountOfUseModalOpen={this.props::handleEditAmountOfUseModalOpen}
                        product={this.props.product}
                        productStatusChangeModal={this.props.productDetailsStatusChangeModal}
                        updateAmountOfUseMeasurement={this.props.updateAmountOfUseMeasurement}
                        updateStatus={this.props::handleUpdateStatus}
                    />
                    <WarrantyCoverage
                        isSapUp={this.props.isSapUp}
                        maintenancePlanLink={true}
                        onClick={linkToMaintenancePlanPanel.bind(this.props)}
                        pin={this.props.product.pin}
                        showDisabledClass={showDisabledClass(this.props.product.status[0].key)}
                        showPartsCoverageSearchButton={true}
                        warranties={this.props.warranties}
                    />
                    {this.props.isSapUp &&
                    <div className='accordion-buttons'>
                        <button
                            className='button-text'
                            onClick={onAccordionButtonClick.bind(this.props, true)}
                        >
                            <FormattedMessage id='EXPAND_ALL'/>
                        </button>
                        <button
                            className='button-text'
                            onClick={onAccordionButtonClick.bind(this.props, false)}
                        >
                            <FormattedMessage id='COLLAPSE_ALL'/>
                        </button>
                    </div>
                }
                    {this.props.externalNotes.notes.length > 0 && this.props.isSapUp &&
                        <ExternalNotesPanel
                            externalNotes={this.props.externalNotes}
                            isExpanded={this.props.accordions.externalNotesIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'externalNotesIsExpanded')}
                        />
                    }
                    {this.props.externalNotes.internalNotes.length > 0 && this.props.isSapUp &&
                        <InternalNotesPanel
                            internalNotes={this.props.externalNotes}
                            isExpanded={this.props.accordions.internalNotesIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'internalNotesIsExpanded')}
                        />
                    }
                    {this.props.isSapUp &&
                        <AmountOfUseHistoryPanel
                            amountOfUseHistory={this.props.amountOfUseHistory}
                            isExpanded={this.props.accordions.amountOfUseIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'amountOfUseIsExpanded')}
                        />
                    }
                    {this.props.isSapUp &&
                        <ComponentsPanel
                            canAddDeleteComponent={hasAccess(this.context.security, 'PRT', 'PRT_COMP_UPDATE')}
                            component={this.props.componentToAdd}
                            componentCodes={this.props.componentCodes}
                            components={this.props.components}
                            isExpanded={this.props.accordions.componentsIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'componentsIsExpanded')}
                            onCreateComponent={this.props::handleCreateComponent}
                            onDelete={this.props::handleComponentDelete}
                            onInputChange={this.props::handleInputChange}
                            onPartNumberBlur={this.props::handlePartNumberBlur}
                            pin={this.props.product.pin}
                            showAddComponentRow={this.props.showAddComponentRow}
                        />
                    }
                    {this.props.isSapUp &&
                        <OptionCodesPanel
                            canAddDeleteOption={hasAccess(this.context.security, 'PRT', 'PRT_OPTION_UPDATE')}
                            isExpanded={this.props.accordions.optionCodesIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'optionCodesIsExpanded')}
                            onCreateOption={this.props::handleCreateOption}
                            onDelete={this.props::handleOptionDelete}
                            onInputChange={this.props::handleOptionInputChange}
                            option={this.props.optionToAdd}
                            options={this.props.optionCodes}
                            pin={this.props.product.pin}
                        />
                    }
                    {this.props.isSapUp &&
                        <MaintenancePlanPanel
                            isExpanded={this.props.accordions.maintenancePlanIsExpanded}
                            maintenancePlans={this.props.maintenancePlans}
                            onClick={onAccordionToggle.bind(this.props, 'maintenancePlanIsExpanded')}
                        />
                    }
                    {this.props.isSapUp &&
                        <ClaimHistoryPanel
                            actions={this.props.actions}
                            claims={this.props.claims}
                            isExpanded={this.props.accordions.pastClaimsIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'pastClaimsIsExpanded')}
                            pin={this.props.product.pin}
                        />
                    }
                    {this.props.isSapUp &&
                        <PipHistoryPanel
                            isExpanded={this.props.accordions.pipHistoryIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'pipHistoryIsExpanded')}
                            pin={this.props.product.pin}
                            pips={this.props.pips}
                        />
                    }
                    {this.props.isSapUp &&
                        <RegistrationHistoryPanel
                            actions={this.props.actions}
                            isExpanded={this.props.accordions.registrationHistoryIsExpanded}
                            isRegistrationFormNotAllowed={this.context.user.privacy.registrationFormNotAllowed}
                            language={this.context.user.getLocale()}
                            onClick={onAccordionToggle.bind(this.props, 'registrationHistoryIsExpanded')}
                            registrationHistory={this.props.registrationHistoryList}
                            security={this.context.security}
                            user={this.context.user}
                        />
                    }
                    {
                        this.props.isSapUp && this.props.baseMachineComponents.isBaseMachineComponentAllowed &&
                        <BaseMachinePanel
                            actions={this.props.actions}
                            baseMachineComponents={this.props.baseMachineComponents}
                            baseMachinePurchaseOrder={this.props.baseMachinePurchaseOrder}
                            isExpanded={this.props.accordions.baseMachineComponentsIsExpanded}
                            isSubmitDisabled={isSubmitDisabled}
                            onCancelImplements={this.props::handleCancelImplements}
                            onClick={onAccordionToggle.bind(this.props, 'baseMachineComponentsIsExpanded')}
                            onInputChange={this.props::handlePurchaseOrderChange}
                            onInputChangeValue={this.props::handleComponentsChange}
                            onSubmitImplements={this.props::handleBaseMachineImplements}
                        />
                    }
                    {this.props.incentivePrograms.length !== 0 &&
                        <IncentiveProgramsPanel
                            actions={this.props.actions}
                            incentivePrograms={this.props.incentivePrograms}
                            isExpanded={this.props.accordions.incentiveProgransIsExpanded}
                            onClick={onAccordionToggle.bind(this.props, 'incentiveProgransIsExpanded')}
                            pin={this.props.product.pin}
                        />
                    }
                </main>
                <aside>
                    <CustomerPanel
                        customer={this.props.customer}
                        customerPanelActionList={customerPanelActionList}
                        isCkcCustomerFailed={this.props.isCkcCustomerFailed}
                        product={this.props.product}
                        showActionsButton={true}
                    />
                    <PurchaseInfoPanel
                        product={this.props.product}
                    />
                </aside>
                <CreateClaimModal
                    claimTypes={this.props.createClaimModal.claimTypes}
                    isModalOpen={this.props.createClaimModal.isModalOpen}
                    onClick={this.props::handleClick}
                    onCloseButtonClick={this.props::handleCloseCreateClaimModal}
                    selectedPin={this.props.product.pin}
                />
            </div>
        );

    }

}

ProductDetails.displayName = 'ProductDetails';
ProductDetails.propTypes = {
    accordions: PropTypes.instanceOf(Accordions).isRequired,
    actions: PropTypes.object.isRequired,
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    baseMachineComponents: PropTypes.instanceOf(Implements).isRequired,
    baseMachinePurchaseOrder: PropTypes.string.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(Claim)).isRequired,
    componentCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    componentToAdd: PropTypes.instanceOf(ProductComponent).isRequired,
    components: PropTypes.arrayOf(PropTypes.instanceOf(ProductComponent)).isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    externalNotes: PropTypes.instanceOf(ExternalNotes).isRequired,
    incentivePrograms: PropTypes.arrayOf(PropTypes.instanceOf(IncentivePrograms)).isRequired,
    isAmountOfUseEditModalOpen: PropTypes.bool.isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    isCkcCustomerFailed: PropTypes.bool.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    maintenancePlans: PropTypes.arrayOf(PropTypes.instanceOf(MaintenancePlan)).isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    optionCodes: PropTypes.arrayOf(PropTypes.instanceOf(Option)).isRequired,
    optionToAdd: PropTypes.instanceOf(Option).isRequired,
    pips: PropTypes.arrayOf(PropTypes.instanceOf(PipHistory)).isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    productDetailsStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    registrationHistoryList: PropTypes.arrayOf(PropTypes.instanceOf(RegistrationHistory)).isRequired,
    routeParams: PropTypes.object.isRequired,
    showAddComponentRow: PropTypes.bool.isRequired,
    updateAmountOfUseMeasurement: PropTypes.instanceOf(MeasurementReading),
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired
};
ProductDetails.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ProductDetails;



// WEBPACK FOOTER //
// ./src/product/details/components/product-details.js